import styled, { keyframes } from "styled-components";

// Animation keyframes
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const scaleInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const BotReferralContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  width: 100%;

  .text-muted {
    margin-bottom: 0px !important;
  }
`

export const MainHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: center;

  width: 100%;
  max-width: 1600px;
  padding: 32px;
  margin-top: 30px;
  gap: 32px;

  background: linear-gradient(135deg, #192619 0%, #111e12 100%);
  border-radius: 20px;
  border: 1px solid rgba(150, 206, 78, 0.1);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(30px)'};
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, transparent, #96CE4E, transparent);
  }

  @media (max-width: 768px) {
    padding: 24px;
    margin-top: 20px;
    gap: 24px;
  }
`

export const SecondaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: center;

  width: 100%;
  max-width: 1600px;
  padding: 32px;
  margin-top: 30px;
  gap: 32px;

  background: linear-gradient(135deg, #192619 0%, #111e12 100%);
  border-radius: 20px;
  border: 1px solid rgba(150, 206, 78, 0.1);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(30px)'};
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, transparent, #96CE4E, transparent);
  }

  @media (max-width: 768px) {
    padding: 24px;
    margin-top: 20px;
    gap: 24px;
  }
`

export const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: 800;
  letter-spacing: -0.04em;
  width: 100%;
  font-size: 36px;
  align-self: flex-start;
  color: #fff;
  margin: 0;
  position: relative;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: ${props => props.isVisible ? '80px' : '0'};
    height: 4px;
    background: linear-gradient(90deg, #96CE4E, #7fb83e);
    border-radius: 2px;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const TopSection = styled.div`
  display: flex;
  width: 100%;
  gap: 40px;
  align-items: center;
  background-color: #111e12;
  border-radius: 14px;
  padding: 20px;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`

export const ReferralImage = styled.img`
  width: 250px;
  height: 250px;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 180px;
    height: 180px;
  }
`

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;
  width: 100%;
`;

export const StatsSection = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const StatBox = styled.div`
  background: linear-gradient(135deg, #1C2D1C 0%, #162216 100%);
  border-radius: 16px;
  border: 1px solid rgba(150, 206, 78, 0.1);
  padding: 48px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex: 1;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)'};
  transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => props.delay || '0ms'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(150, 206, 78, 0.5), transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: ${props => props.isVisible ? 'translateY(-4px) scale(1)' : 'translateY(30px) scale(0.95)'};
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
    border-color: rgba(150, 206, 78, 0.2);

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    padding: 32px 24px;
    gap: 20px;
  }
`;

export const StatIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 80px;
    height: 80px;
    object-fit: contain;

    @media (max-width: 768px) {
      width: 48px;
      height: 48px;
    }
  }
`;

export const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
`;

export const StatLabel = styled.div`
  font-size: 18px;
  color: #96CE4E;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StatValue = styled.div`
  font-size: 42px;
  font-weight: 800;
  color: ${props => props.color || '#fff'};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const ReferralLink = styled.div`
  width: 100%;
  background: #111e12;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
    gap: 15px;
  }
`;

export const LinkInput = styled.input`
  flex: 1;
  background: #1d2d1d;
  border: none;
  padding: 15px 20px;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  outline: none;

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 15px;
    font-size: 14px;
  }
`;

export const ShareButton = styled.button`
  background: #96CE4E;
  color: #111e12;
  border: none;
  padding: 15px 40px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
`;

export const RewardText = styled.div`
  color: #94a3b8;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: #38bdf8;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    justify-content: center;
  }
`;

export const ExplainerSection = styled.div`
  background: linear-gradient(135deg, #223322 0%, #1a2d1a 100%);
  border-radius: 16px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  border: 1px solid rgba(150, 206, 78, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  position: relative;
  overflow: hidden;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(30px)'};
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #96CE4E, transparent);
  }

  @media (max-width: 768px) {
    padding: 24px;
    gap: 20px;
  }
`;

export const ExplainerTitle = styled.h2`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 28px;
  color: #fff;
  margin: 0;
  text-align: center;
  position: relative;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: ${props => props.isVisible ? '60px' : '0'};
    height: 3px;
    background: linear-gradient(90deg, #96CE4E, #7fb83e);
    border-radius: 2px;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s;
  }

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const ExplainerText = styled.div`
  color: #e6ffe6;
  font-size: 17px;
  line-height: 1.7;
  white-space: pre-line;
  text-align: center;

  strong {
    color: #96CE4E;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 1.6;
  }
`;

export const ExplainerCTA = styled.button`
  background: #96CE4E;
  color: #111e12;
  border: none;
  padding: 15px 40px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s;
  align-self: flex-start;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
`;

export const FAQSection = styled.div`
  background: linear-gradient(135deg, #223322 0%, #1a2d1a 100%);
  border-radius: 16px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  border: 1px solid rgba(150, 206, 78, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  position: relative;
  overflow: hidden;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(30px)'};
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #96CE4E, transparent);
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const FAQTitle = styled.h2`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 28px;
  color: #fff;
  margin: 0 0 32px 0;
  text-align: center;
  position: relative;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: ${props => props.isVisible ? '60px' : '0'};
    height: 3px;
    background: linear-gradient(90deg, #96CE4E, #7fb83e);
    border-radius: 2px;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 24px;
  }
`;

export const FAQItem = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(150, 206, 78, 0.1);
  border-radius: 12px;
  margin-bottom: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => props.delay || '0ms'};

  &:hover {
    background: rgba(150, 206, 78, 0.05);
    border-color: rgba(150, 206, 78, 0.2);
    transform: ${props => props.isVisible ? 'translateY(-2px)' : 'translateY(20px)'};
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FAQQuestion = styled.h3`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 18px;
  color: #96CE4E;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  position: relative;
  transition: all 0.3s ease;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-right: 2px solid #96CE4E;
    border-bottom: 2px solid #96CE4E;
    transform: ${props => props.isOpen ? 'rotate(-135deg) translateY(2px)' : 'rotate(45deg)'};
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
    margin-left: 16px;
  }

  &:hover {
    color: #b8e76b;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 16px 20px;
  }
`;

export const FAQAnswer = styled.div`
  color: #e6ffe6;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
  max-height: ${props => props.isOpen ? '300px' : '0'};
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${props => props.isOpen ? '1' : '0'};
  padding: ${props => props.isOpen ? '12px 24px 24px 24px' : '0 24px'};
  border-top: ${props => props.isOpen ? '1px solid rgba(150, 206, 78, 0.1)' : 'none'};

  @media (max-width: 768px) {
    font-size: 14px;
    padding: ${props => props.isOpen ? '12px 20px 20px 20px' : '0 20px'};
  }
`;

export const ReferralsTable = styled.div`
  width: 100%;
  background: #111e12;
  border-radius: 12px;
  padding: 30px;
  margin-top: 30px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const ReferralsTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ReferralsTableTitle = styled.h2`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 28px;
  color: #fff;
  margin: 0;
  position: relative;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: ${props => props.isVisible ? '60px' : '0'};
    height: 3px;
    background: linear-gradient(90deg, #96CE4E, #7fb83e);
    border-radius: 2px;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s;
  }

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const ReferralsTableContent = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: white;
`;

export const TableHead = styled.thead`
  background: #1C2D1C;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background: #1C2D1C;
  }
`;

export const TableHeader = styled.th`
  padding: 15px;
  text-align: left;
  font-weight: 600;
  color: #96CE4E;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 12px;
  }
`;

export const TableCell = styled.td`
  padding: 15px;
  font-size: 14px;
  border-bottom: 1px solid #2A3A2A;

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 12px;
  }
`;

export const NoReferrals = styled.div`
  text-align: center;
  padding: 60px 40px;
  color: #96CE4E;
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, rgba(150, 206, 78, 0.05) 0%, rgba(150, 206, 78, 0.02) 100%);
  border: 2px dashed rgba(150, 206, 78, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    padding: 40px 24px;
    font-size: 16px;
  }
`;

export const ReferralCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s;
`;

export const ReferralCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #223322 0%, #1a2d1a 100%);
  border: 1px solid rgba(150, 206, 78, 0.1);
  border-radius: 16px;
  padding: 24px 32px;
  margin-bottom: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.98)'};
  transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => props.delay || '0ms'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(150, 206, 78, 0.5), transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: ${props => props.isVisible ? 'translateY(-2px) scale(1)' : 'translateY(30px) scale(0.98)'};
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    border-color: rgba(150, 206, 78, 0.2);

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 24px;
    gap: 20px;
  }
`;

export const ReferralCardLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex: 1;

  @media (max-width: 768px) {
    align-items: center;
    gap: 16px;
  }
`;

export const ReferralCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    gap: 12px;
    flex: 1;
  }
`;

export const ReferralCardIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2d402d 0%, #243324 100%);
  border: 1px solid rgba(150, 206, 78, 0.2);
  border-radius: 50%;
  color: #96CE4E;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  flex-shrink: 0;

  ${ReferralCard}:hover & {
    background: linear-gradient(135deg, #3a4d3a 0%, #2d402d 100%);
    border-color: rgba(150, 206, 78, 0.3);
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 22px;
  }
`;

export const ReferralCardEmail = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #e6ffe6;
  word-break: break-all;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
`;

export const ReferralCardDate = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b6cdb6;
  font-size: 14px;
  font-weight: 500;

  svg {
    transition: color 0.3s ease;
    flex-shrink: 0;
  }

  ${ReferralCard}:hover & {
    color: #c7ddc7;

    svg {
      stroke: #96CE4E;
    }
  }

  @media (max-width: 768px) {
    font-size: 15px;
    font-weight: 600;
    color: #96CE4E;

    svg {
      width: 20px;
      height: 20px;
      stroke: #96CE4E;
    }
  }
`;

export const ReferralCardEarnings = styled.div`
  color: #96CE4E;
  font-size: 20px;
  font-weight: 800;
  margin-left: 32px;
  min-width: 100px;
  text-align: right;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  ${ReferralCard}:hover & {
    color: #b8e76b;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 0;
    min-width: unset;
    text-align: center;
    font-size: 24px;
    font-weight: 900;
    padding: 12px 20px;
    background: linear-gradient(135deg, rgba(150, 206, 78, 0.1) 0%, rgba(150, 206, 78, 0.05) 100%);
    border: 1px solid rgba(150, 206, 78, 0.2);
    border-radius: 12px;
    color: #96CE4E;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
`;

export const CommissionCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
  margin: 32px 0;

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 24px 0;
  }
`;

export const CommissionCard = styled.div`
  background: linear-gradient(135deg, #2d402d 0%, #243324 100%);
  border: 1px solid rgba(150, 206, 78, 0.2);
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);

  /* Animation properties */
  opacity: ${props => props.isVisible ? 1 : 0};
  transform: ${props => props.isVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)'};
  transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => props.delay || '0ms'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, transparent, #96CE4E, transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: ${props => props.isVisible ? 'translateY(-6px) scale(1)' : 'translateY(30px) scale(0.95)'};
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
    border-color: rgba(150, 206, 78, 0.4);

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    padding: 28px 20px;
  }
`;

export const CommissionPercentage = styled.div`
  font-size: 48px;
  font-weight: 800;
  color: #96CE4E;
  text-shadow: 0 2px 8px rgba(150, 206, 78, 0.3);
  margin-bottom: 16px;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 40px;
    margin-bottom: 12px;
  }
`;

export const CommissionRange = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #e6ffe6;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;